import { useQuery } from '@tanstack/react-query';
import { CRMUserData } from '../../../@types/api';
import { QUERY_KEYS } from '../../../constants';
import API_ROUTES from '../../../constants/apiRoutes';
import { useCRMUser } from '../../../contexts/CRMUserContext';
import { getData } from '../../../utils/api';

const useCommissionQueries = <TCommission>() => {
  const { selectedCRMUser } = useCRMUser();
  const selectedCRMUserId = selectedCRMUser?.id;

  const userQuery = useQuery<CRMUserData>({
    queryKey: [QUERY_KEYS.crmUsers, selectedCRMUserId],
    queryFn: () => getData(`${API_ROUTES.CRM.AGENT_BY_ID}/${selectedCRMUserId}`, undefined, 'crm'),
    enabled: !!selectedCRMUserId,
  });

  const commissionQuery = useQuery<TCommission>({
    queryKey: [QUERY_KEYS.crmCommissions, selectedCRMUserId],
    queryFn: () => getData(`${API_ROUTES.CRM.AGENT_COMMISSION}/${selectedCRMUserId}`, undefined, 'crm'),
    enabled: !!selectedCRMUserId,
  });

  return {
    selectedCRMUserId,
    userData: userQuery.data,
    commissionData: commissionQuery.data,
    isCommissionLoading: commissionQuery.isPending,
    isCommissionError: commissionQuery.isError,
    isCommissionSuccess: commissionQuery.isSuccess,
  };
};

export default useCommissionQueries;
